import React from "react";
import { useQuery } from "@apollo/client";
import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { GET_SERVICE_CONNECTIONS } from "../../../queries/archiveQrys/InventoryReportQueries";
import {
  serviceConnectionType,
  serviceConnectionMeterType
} from "../../../utilities/constants/ServiceConnectionConstants";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const ServiceConnectionTable = ({ systemId }) => {
  const columns = [
    {
      Header: "Type",
      accessor: (d) => {
        return d.connectionType ? serviceConnectionType[d.connectionType] : "";
      }
    },
    {
      Header: "Meter Type",
      accessor: (d) => {
        return d.meterType ? serviceConnectionMeterType[d.meterType] : "";
      }
    },
    {
      Header: "Meter Size",
      accessor: "meterSize"
    },
    {
      Header: "Number of Connections",
      accessor: "numberOfConnections"
    }
  ];

  const { loading, error, data } = useQuery(GET_SERVICE_CONNECTIONS, { variables: { systemId } });
  if (loading) return <SkeletonLoader width='100%' />;
  if (error) return <ErrorHandler error={error} />;

  return (
    <>
      {data.getInventoryServiceConnectionsBySystemId.length > 0 ? (
        <DtsReactTable data={data.getInventoryServiceConnectionsBySystemId} columns={columns} headerColor='ddw' cypressid="ServiceConnectionsTbl" />
      ) : (
        <span>
          <em>No service connection information was found in the database.</em>
        </span>
      )}
    </>
  );
};

export default ServiceConnectionTable;
